module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"tasks":"Tasks"},"table":{"headers":{"name":"Task name","step":"Step","priority":"Priority","startDate":"Start date","endDate":"End date","assignedTo":"Assigned to","actionBy":"Action by","status":"Status"}}}}')
  delete Component.options._Ctor
}
